document.addEventListener('DOMContentLoaded', () => {

  const body = document.body.classList;
  const pathname = window.location.pathname;

  let pageType = 'other';
  if (body.contains('home')) pageType = 'home';
  else if (body.contains('single-room')) pageType = 'room';
  else if (body.contains('post-type-archive-room')) pageType = 'room-list';
  else if (body.contains('post-type-archive-offer')) pageType = 'offer-list';
  else if (body.contains('single-booking')) pageType = 'booking';
  else if (body.contains('single-contact')) pageType = 'contact';
  else if (body.contains('single-gallery')) pageType = 'gallery';
  else if (body.contains('error404')) pageType = 'error';
  else if (body.contains('search')) pageType = 'search';

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': 'datalayer-loaded',
    'page_type': pageType,
    'arbo': pathname,
  });

  const params = new URLSearchParams(window.location.search);
  const formParam = params.get('form');

  if (formParam === 'contact') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'contact-form-success',
      'form_id': params.get('form_id') || '',
      'user_email_sha256': params.get('user_email_sha256') || '',
    });
  }

  if (formParam === 'devis') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'devis-form-success',
      'form_subject': params.get('form_subject') || '',
      'form_id': params.get('form_id') || '',
      'user_email_sha256': params.get('user_email_sha256') || '',
    });
  }

  const dataLayerElements = document.querySelectorAll('[data-event]');

  dataLayerElements.forEach(el => {
    el.addEventListener('click', () => {
      const eventEvent = el.getAttribute('data-event');
      const eventName = el.getAttribute('data-name');
      const eventPosition = el.getAttribute('data-position');
      const eventSocialNetwork = el.getAttribute('data-social-network');

      if (eventEvent === 'clic_cta') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': eventEvent,
          'cta_name': eventName,
          'html_cta': eventPosition,
        });
      }

      if (eventEvent === 'clic_social_networks') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': eventEvent,
          'clic_social_networks': {
            'social_network_clicked': eventSocialNetwork,
          },
        });
      }
    });
  });
});
